import React from "react";
import { Modal } from "react-bootstrap";
import "../styles.css";
import { InfoIcon, TrialSuccessIcon } from "./icons/icons";

const TrialSuccessModal = ({ show, onClose, selectedPlan, isTrial }) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            className="trial-success-modal"
        >
            <div className="trial-success-top-banner mb-4">
                <div className="trial-success-icon-container d-flex justify-content-center">
                    <div className="trial-success-icon-circle d-flex align-items-center justify-content-center">
                        <TrialSuccessIcon />
                    </div>
                </div>
            </div>
            <Modal.Body className="trial-success-modal-body d-flex flex-column gap-3 pt-5">
                <div className="trial-success-modal-title text-center">
                    ¡Bienvenido a bordo!
                </div>

                <div className="trial-success-modal-subtitle text-center">
                    {isTrial ? (
                        <>Tu prueba gratuita del plan <strong>{selectedPlan}</strong> ha comenzado exitosamente.<br /></>
                    ) : (
                        <>Tu suscripción al plan <strong>{selectedPlan}</strong> ha comenzado exitosamente.<br /></>
                    )}
                </div>

                <div className="trial-success-next-steps d-flex flex-column gap-3">

                    <div className="trial-success-next-steps-title d-flex flex-row align-items-center gap-1">
                        <InfoIcon />
                        Próximos pasos:
                    </div>

                    <ul className="trial-success-next-steps-list d-flex flex-column gap-3 p-0 m-0">

                        <li className="d-flex flex-row gap-3">
                            <span className="trial-success-step-number success"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none">
                                <path d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM10.9326 13.5176L8.70703 11.293L7.29297 12.707L11.0674 16.4814L11.7686 15.6406L16.7686 9.64062L15.2314 8.35938L10.9326 13.5176Z" fill="#6FD195" />
                            </svg>
                            </span>
                            <div className="trial-success-step-text">
                                <strong className="fw-semibold">Perfil Configurado:</strong> Tus datos básicos y documentos legales (PDFs) ya han sido cargados exitosamente.
                            </div>
                        </li>

                        <li className="d-flex flex-row gap-3">
                            <span className="trial-success-step-number">2</span>
                            <div className="trial-success-step-text">
                                <strong className="fw-semibold">Empieza a Operar:</strong> Ya puedes gestionar tus reservas, atletas y planes desde el Dashboard.
                            </div>
                        </li>

                        <li className="d-flex flex-row gap-3">
                            <span className="trial-success-step-number">3</span>
                            <div className="trial-success-step-text">
                                <strong className="fw-semibold">Soporte Personalizado:</strong> Un especialista te contactará en 48h para resolver dudas específicas.
                            </div>
                        </li>

                    </ul>
                </div>

                <div className="d-flex justify-content-center">
                    <button
                        className="trial-success-primary-button"
                        onClick={onClose}
                    >
                        Ir a mi Dashboard
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 12L18.7071 11.2929L19.4142 12L18.7071 12.7071L18 12ZM6 13C5.44771 13 5 12.5523 5 12C5 11.4477 5.44771 11 6 11V12V13ZM14 8L14.7071 7.29289L18.7071 11.2929L18 12L17.2929 12.7071L13.2929 8.70711L14 8ZM18 12L18.7071 12.7071L14.7071 16.7071L14 16L13.2929 15.2929L17.2929 11.2929L18 12ZM18 12V13H6V12V11H18V12Z" fill="white" />
                        </svg>
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default TrialSuccessModal;
